
import React from "react";
import { useWaitlist } from "@/hooks/use-waitlist";
import { PrimaryButton, GuideButton } from "./sidebar/ActionButtons";
import { SidebarLinks } from "./sidebar/SidebarLinks";

interface SidebarCTAProps {
  centerName: string;
  email?: string;
  nhSlug: string;
  countySlug: string;
  hiqaProfileUrl?: string;
}

export function SidebarCTA({ centerName, email, nhSlug, countySlug, hiqaProfileUrl }: SidebarCTAProps) {
  const { isInLeads, handleJoinWaitlist } = useWaitlist({ 
    nhSlug, 
    centerName, 
    countySlug, 
    email 
  });

  const handleGuideDownload = () => {
    window.open('/guides/fair-deal', '_blank');
  };

  return (
    <div className="bg-grandpal-beige rounded-lg p-5 mb-6 shadow-sm">
      <h2 className="text-xl font-semibold mb-2">Take the Next Step</h2>
      <p className="text-gray-700 mb-4">
        Ready to learn more about {centerName}? Our advisors can help guide you through the process.
      </p>
      
      <div className="space-y-3">
        <PrimaryButton 
          isInLeads={isInLeads} 
          onJoinWaitlist={handleJoinWaitlist} 
        />
        
        <div className="grid grid-cols-1 gap-3">
          <GuideButton onClick={handleGuideDownload} />
        </div>
        
        <SidebarLinks 
          hiqaProfileUrl={hiqaProfileUrl} 
          centerName={centerName} 
        />
      </div>
    </div>
  );
}
